import notificationClient from '../../api/notificationClient';
import { Api_Keys_Url, Api_Key_Url } from '../../api/endpoints';

// sk-notification's OWN API keys (the ApiKey table), managed via /admin/api-keys.
// Keys external callers use to POST /notify — NOT platform credentials.
export interface ApiKeyRecord {
  id: string;
  name: string;
  productId: string;
  prefix: string;
  scopes: string[];
  isAdmin: boolean;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

export interface IssuedApiKey {
  plaintext: string;
  key: ApiKeyRecord;
  warning: string;
}

export const listApiKeys = async (productId?: string): Promise<ApiKeyRecord[]> => {
  const { data } = await notificationClient.get<{ keys: ApiKeyRecord[] }>(Api_Keys_Url, {
    params: productId ? { productId } : undefined,
  });
  return data.keys;
};

export const issueApiKey = async (input: {
  name: string;
  productId: string;
  isAdmin?: boolean;
}): Promise<IssuedApiKey> => {
  const { data } = await notificationClient.post<IssuedApiKey>(Api_Keys_Url, input);
  return data;
};

export const revokeApiKey = async (id: string): Promise<void> => {
  await notificationClient.delete(Api_Key_Url(id));
};
